var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from 'react';
import { SmartCheck, SmartChatTypes } from '../states';
import { sendMessageWithTypingDecorator } from '../decorators';
import { CODE_VERIFIED_ERROR_MESSAGE, BLOCKED_USER_ERROR_MESSAGE, TOO_MANY_ATTEMPTS_MESSAGE, NUMBER_NOT_WORKING, } from '../Constants/index';
import { ErrorCodes } from '@lendi/lala-react';
import { analytics, ChatEventName, EventCategory } from '../../../../analytics';
import { useError } from '../../../../providers/ErrorProvider/context';
export var useAuthError = function (chatState, authState, chatDispatch) {
    var error = authState.error;
    var messages = chatState.messages, checkpoint = chatState.checkpoint;
    var onException = useError().onException;
    function authErrorHandler() {
        return __awaiter(this, void 0, void 0, function () {
            var oldIndex, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(checkpoint === SmartCheck.ON_ERROR_CHECK)) return [3 /*break*/, 11];
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        _a = error.code;
                        switch (_a) {
                            case ErrorCodes.ACCESS_DENIED: return [3 /*break*/, 1];
                            case ErrorCodes.TOO_MANY_ATTEMPTS: return [3 /*break*/, 3];
                            case ErrorCodes.BLOCKED_USER: return [3 /*break*/, 5];
                            case ErrorCodes.NUMBER_NOT_WORKING: return [3 /*break*/, 7];
                            case ErrorCodes.GENERIC: return [3 /*break*/, 9];
                            case ErrorCodes.SMS_PROVIDER_ERROR: return [3 /*break*/, 9];
                            case ErrorCodes.PARSE_STATE: return [3 /*break*/, 9];
                        }
                        return [3 /*break*/, 9];
                    case 1: // when code verification failed
                    return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, CODE_VERIFIED_ERROR_MESSAGE, ++oldIndex)];
                    case 2:
                        _b.sent();
                        chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: SmartCheck.ON_CODE_VALIDATION_CHECK });
                        return [3 /*break*/, 10];
                    case 3: // when user keep trying with incorrect code
                    return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, TOO_MANY_ATTEMPTS_MESSAGE, ++oldIndex)];
                    case 4:
                        _b.sent();
                        // timeout actions
                        chatDispatch({ type: SmartChatTypes.SHOW_SEND_CODE_ACTION });
                        chatDispatch({ type: SmartChatTypes.SHOW_CHANGE_PHONE_ACTION });
                        return [3 /*break*/, 10];
                    case 5: // when a blocked user trying to access
                    return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, BLOCKED_USER_ERROR_MESSAGE, ++oldIndex)];
                    case 6:
                        _b.sent();
                        analytics({
                            event_name: ChatEventName.CONTACT_US_SHOWN,
                            category: EventCategory.CHAT,
                        });
                        chatDispatch({ type: SmartChatTypes.SHOW_CONTANT_US });
                        return [3 /*break*/, 10];
                    case 7: return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, NUMBER_NOT_WORKING, ++oldIndex)];
                    case 8:
                        _b.sent();
                        chatDispatch({ type: SmartChatTypes.SHOW_CHANGE_PHONE_ACTION });
                        return [3 /*break*/, 10];
                    case 9:
                        // show error page
                        chatDispatch({ type: SmartChatTypes.SHOW_FATAL_ERROR_PAGE });
                        return [3 /*break*/, 10];
                    case 10:
                        onException(new Error("@lendi/chat: SmartChat: error captured while interacting with @lendi/lala-react: ".concat(error.description)));
                        _b.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        authErrorHandler();
    }, [checkpoint]);
};
//# sourceMappingURL=useAuthError.js.map